export default String.raw`
<div class="customer-submenu">
    <div class="customer-submenu__header submenu-header">
        <div class="navigation-header">
            <button class="pure-button load-erp-data-js load-first-lvl-js parent-container-reload-js" data-template="partials/customer-profile/wm/wm.html" data-url="{{page.Url}}?tab=wm">
                <svg width="24" height="24">
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#long-arrow-left-{{settings.iconStyle}}"></use>
                </svg>
            </button>
            <div class="erp-name">
                {{ translations.Document }}<div class="erp-number-js hidden-js"></div>
            </div>
        </div>
    </div>
    <div class="erp-data-container-js" style="display: none">
        <div class="info-container-js expandable-mechanism-container-js">
            <div class="details-info">
                <div class="details">
                    <div class="customer-info__content">
                        <div class="title">{{ translations.BuyDate }}</div>
                        <span>{ Date | date }</span>
                    </div>
                    <div class="customer-info__content">
                        <div class="title">{{ translations.ReleaseDate }}</div>
                        <span>{ ReleaseDate | date }</span>
                    </div>
                </div>
            </div>
            <button class="pure-button expand-data-js change-arrow-title-js" title="{{ translations.ShowDetails }}">
				{{ translations.ShowDetails }} 
				<svg height="16" width="16" class="icon rotate-down dropdown-arrow">
					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
				</svg>
			</button>
			<div class="order-details expandable-js">
                <div class="order-details__row">
                    <div class="order-details-item">
                        <div class="title">{{ translations.Stock }}</div>
                        <span>{ Warehouse }</span>
                    </div>
                </div>
                <div class="order-details__row">
                    <div class="order-details-item" rv-if="EmailExists">
                        <div class="title">{{ translations.BoughtBy }}</div>
                        <span>{ Email }</span>
                    </div>
                    <div class="order-details-item" rv-if="StreetExists">
                        <div class="title">{{ translations.ReciverData }}</div>
                        <span>{ Name1 }</span>
                        <span>{ Name2 }</span>
                        <span>{ Street } { StreetNo }<span rv-if="UnitNoExists">/{ UnitNo }</span></span>
                        <span>{ ZipCode } { City }</span>
                    </div>
                    <div class="order-details-item" rv-if="InvoiceStreetExists">
                        <div class="title">{{ translations.BuyerData }}</div>
                        <span>{ InvoiceName1 }</span>
                        <span>{ InvoiceName2 }</span>
                        <span>{ InvoiceTIN }</span>
                        <span>{ InvoiceStreet } { InvoiceStreetNo }<span rv-if="InvoiceUnitNoExists">/{ InvoiceUnitNo }</span></span>
                        <span>{ InvoiceZipCode } { InvoiceCity }</span>
                    </div>
                </div>
                <div class="header-attributes-js" rv-if="AttributesExist"></div>
            </div>
        </div>
        <div class="wm-products-list-js container-js">
            {% include 'partials/customer-profile/products-list.html' with 'wm' -%}
        </div>
        <div class="related-erp">
            <h5>{{ translations.RelatedDocuments }}</h5>
            <div class="eshop__table-container waybills" rv-if="DocumentsExist">
                <table>
                    <colgroup>
                        <col style="width:200px">
                        <col style="width:100px">
                        <col style="width:100px">
                        <col style="width:100px">
                    </colgroup>
                    <thead>
                        <tr>
                            <th class="id">{{ translations.Number | Capitalize }}</th>
                            <th>{{ translations.DocumentDate }}</th>
                            <th>{{ translations.Value }} {{ translations.Netto | Downcase }}</th>
                            <th>{{ translations.Value }} {{ translations.Brutto | Downcase }}</th>
                            <th>{{ translations.Currency }}</th>
                        </tr>
                    </thead>
                    <tbody class="related-documents-js {% if settings.erpOrdersAvailability == 'yes' -%} erpOrdersAvailable-js {% endif -%} {% if settings.invoicesAvailability == 'yes' -%} invoicesAvailable-js {% endif -%} {% if settings.SORAvailability == 'yes' -%} SORAvailable-js {% endif -%}" rv-if="DocumentsExist" data-url-origin="{{ page.Url }}?&deeper-lvl=true&erp-data=true&" data-url-eshop-orders="{{ page.Url }}?{{ customer-profile.OrderQueryGET | H }}=">
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="loader-js loader big"></div>
</div>
`